import { render, staticRenderFns } from "./purchaseAccount.vue?vue&type=template&id=091fd020&scoped=true&"
import script from "./purchaseAccount.vue?vue&type=script&lang=js&"
export * from "./purchaseAccount.vue?vue&type=script&lang=js&"
import style0 from "./purchaseAccount.vue?vue&type=style&index=0&id=091fd020&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "091fd020",
  null
  
)

export default component.exports